import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 201	条件分歧结束
 */

export default class EventIFEnd extends EventBase {
  /**
   * 条件分歧结束的构造函数
   */
  constructor() {
    super()
    this.Parameter = ['']
  }
  /**
   * 剧情ID
   */
  Code = EventID.IFEnd
  /**
   * 显示信息，新版默认为1
   */
  get Description() {
    return this.Parameter?.[0] || ''
  }
  set Description(value) {
    this.Parameter![0] = value.toString()
  }

  /**
   * 获取显示信息
   */
  /// <returns></returns>
}
